import { render, staticRenderFns } from "./paymentPlan.vue?vue&type=template&id=37268126&scoped=true&"
import script from "./paymentPlan.vue?vue&type=script&lang=js&"
export * from "./paymentPlan.vue?vue&type=script&lang=js&"
import style0 from "./paymentPlan.vue?vue&type=style&index=0&id=37268126&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37268126",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37268126')) {
      api.createRecord('37268126', component.options)
    } else {
      api.reload('37268126', component.options)
    }
    module.hot.accept("./paymentPlan.vue?vue&type=template&id=37268126&scoped=true&", function () {
      api.rerender('37268126', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ClientDashboard/payments/paymentPlan.vue"
export default component.exports